import ImportResult from './src/import-result';

export default ImportResult;
